<template>
  <div class="shape-menu">
    <MenuHeader title="形状" />
    <tag-menu :tagList="tabs" v-model="currentTab" class="shape-add" />
    <template v-if="currentTab === 'shape'">
      <div class="shape-list">
        <div class="shape-item" v-for="shape in shapes" :key="shape.type">
          <button type="button" class="shape-icon" @click="add(shape)">
            <shape-renderer
              :params="shape.params"
              class="shape-icon__shape"
              :style="
                shape.type === 'verticalLine'
                  ? { transform: 'rotate(90deg)' }
                  : ''
              "
            />
          </button>
          <a-popover placement="rightTop" overlayClassName="shape-menu-overlay">
            <template slot="content">
              <p class="shape-menu-overlay__name">{{ shape.name }}</p>
              <p v-if="shape.desc" class="shape-menu-overlay__desc">
                {{ shape.desc }}
              </p>
            </template>
            <a-button class="material-action-trigger" type="link">
              <a-icon type="ellipsis" />
            </a-button>
          </a-popover>
          <!-- <div class="shape-item__name">{{ shape.name }}</div> -->
        </div>
      </div>
    </template>
    <template v-else>
      <a-radio-group
        class="header-radio-group"
        v-model="containerType"
        button-style="solid"
      >
        <a-radio-button value="all">全部</a-radio-button>
        <a-radio-button value="containers">普通容器</a-radio-button>
        <a-radio-button value="grids">分屏容器</a-radio-button>
      </a-radio-group>
      <svg width="0" height="0" style="display: block">
        <defs>
          <pattern
            id="containerPattern"
            patternUnits="userSpaceOnUse"
            viewBox="0,0,2,2"
            width=".4"
            height=".4"
          >
            <path d="M0 0L0 1L2 1L2 2L1 2L1 0z" fill="rgba(0,0,0,.2)" />
          </pattern>
        </defs>
      </svg>
      <div class="shape-list">
        <template v-if="showContainers">
          <div class="shape-item" v-for="shape in containers" :key="shape.type">
            <button
              type="button"
              class="shape-icon"
              @click="addContainer(shape)"
            >
              <shape-renderer
                :params="shape.params"
                class="shape-icon__shape"
              />
            </button>
            <a-popover
              placement="rightTop"
              overlayClassName="shape-menu-overlay"
            >
              <template slot="content">
                <p class="shape-menu-overlay__name">{{ shape.name }}</p>
                <p v-if="shape.desc" class="shape-menu-overlay__desc">
                  {{ shape.desc }}
                </p>
              </template>
              <a-button class="material-action-trigger" type="link">
                <a-icon type="ellipsis" />
              </a-button>
            </a-popover>
            <!-- <div class="shape-item__name">{{ shape.name }}</div> -->
          </div>
          <div class="shape-item">
            <button
              type="button"
              @click="addTextContainerItem"
              class="shape-icon"
            >
              <svg
                width="40"
                height="40"
                viewBox="-1 -1 2 2"
                class="shape-icon__shape"
                style="display: block"
              >
                <text
                  font-family="Montserrat-ExtraBold"
                  font-size="2.4"
                  x="0"
                  y="0"
                  text-anchor="middle"
                  dominant-baseline="central"
                  fill="url(#containerPattern)"
                >
                  A
                </text>
              </svg>
            </button>
            <a-popover
              placement="rightTop"
              overlayClassName="shape-menu-overlay"
            >
              <template slot="content">
                <p class="shape-menu-overlay__name">文本容器</p>
                <p class="shape-menu-overlay__desc">可以编辑文本和添加素材。</p>
              </template>
              <a-button class="material-action-trigger" type="link">
                <a-icon type="ellipsis" />
              </a-button>
            </a-popover>
            <!-- <div class="shape-item__name">文本容器</div> -->
          </div>
        </template>
        <template v-if="showGrids">
          <div
            class="shape-item container-grid-item"
            v-for="item in containerGridList"
            :key="item.name"
          >
            <button
              type="button"
              class="shape-icon"
              @click="addContainerGrid(item.name)"
            >
              <shape-renderer
                :params="{
                  shape: 'path',
                  width: 45,
                  height: 30,
                  strokeWidth: 0,
                  color: 'var(--color)',
                  d: item.d,
                  shapeX: 0,
                  shapeY: 0,
                  shapeScale: 1
                }"
                class="shape-icon__shape"
              />
            </button>
          </div>
        </template>
      </div>
    </template>
    <!-- <div class="text-clip-group" v-if="currentTab === 'shape'">
      <div
        v-for="item in shapeList"
        :key="item.id"
        class="text-clip-group-txt"
        :class="{
          'text-clip-group-txt--active': selectedEffectId === item.id
        }"
        @click="handleCurrentText(item.id)"
      >
        <div class="text-clip-tip" v-if="item.showTracks">动态图形</div>
        <div class="text-clip-txt">{{ item.type }}: {{ item.value }}</div>
        <div class="text-clip-op">
          <div v-for="op in opList" :key="op.id">
            <button
              type="button"
              v-if="op.opTextbtn"
              :class="op.attr"
              :title="op.title"
              class="icon iconfont"
              @click="operate($event, op.type, item.id)"
            ></button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MenuHeader from "../base/MenuHeader";
import TagMenu from "../base/TagMenu";
import ShapeRenderer from '../player/ShapeRenderer';
// import CollapseTitle from '../base/CollapseTitle';
import { containerGrids, containerGridIcons } from '../../utils/shapes';

const typeNames = {
  shape: '形状',
  container: '容器',
  textContainer: '文本容器'
};

const displayParams = {
  rect: {
    shape: 'rect',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  ellipse: {
    shape: 'ellipse',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  triangle: {
    shape: 'triangle',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    pointPos: 0,
    color: '#e4e4e4'
  },
  diamond: {
    shape: 'diamond',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  star: {
    shape: 'star',
    width: 40,
    height: 40,
    innerRadius: .38,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    points: 5
  },
  polygon: {
    shape: 'polygon',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    points: 6
  },
  heart: {
    shape: 'heart',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  arc: {
    shape: 'arc',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    innerRadius: .6,
    startAngle: -90,
    endAngle: 90,
    cornerRadius: 1
  },
  ring: {
    shape: 'ring',
    width: 40,
    height: 40,
    innerRadius: .62,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  trapezoid: {
    shape: 'trapezoid',
    width: 40,
    height: 40,
    skewLeft: .5,
    skewRight: -.5,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  arrow: {
    shape: 'arrow',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    arrowWidth: .4
  },
  arcArrow: {
    shape: 'arcArrow',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    outerRadius: .66,
    startAngle: -90,
    endAngle: 90,
    arrowWidth: .27,
    counterclockwise: false
  },
  teardrop: {
    shape: 'teardrop',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  cloud: {
    shape: 'cloud',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4'
  },
  cross: {
    shape: 'cross',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    controlPosition: 1
  },
  rectContainer: {
    shape: 'rect',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  ellipseContainer: {
    shape: 'ellipse',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  triangleContainer: {
    shape: 'triangle',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    pointPos: 0
  },
  diamondContainer: {
    shape: 'diamond',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  starContainer: {
    shape: 'star',
    width: 40,
    height: 40,
    innerRadius: .38,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    points: 5
  },
  polygonContainer: {
    shape: 'polygon',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    points: 6,
    color: 'url(#containerPattern)'
  },
  heartContainer: {
    shape: 'heart',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  arcContainer: {
    shape: 'arc',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    innerRadius: .55,
    startAngle: -90,
    endAngle: 90,
    cornerRadius: 1
  },
  ringContainer: {
    shape: 'ring',
    width: 40,
    height: 40,
    innerRadius: .6,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  line: {
    shape: 'line',
    width: 40,
    height: 2,
    stroke: 'var(--color)'
  },
  verticalLine: {
    shape: 'verticalLine',
    width: 40,
    height: 2,
    stroke: 'var(--color)'
  },
  trapezoidContainer: {
    shape: 'trapezoid',
    width: 40,
    height: 40,
    skewLeft: .5,
    skewRight: -.5,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)'
  },
  chatBubble: {
    shape: 'chatBubble',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    radius: 100
  },
  rectBorderContainer: {
    shape: 'path',
    width: 40,
    height: 40,
    d: 'M-1 -1L1 -1L1 1L-1 1zM-0.6 0.6L0.6 0.6L0.6 -0.6L-0.6 -0.6z',
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    shapeX: 0,
    shapeY: 0,
    shapeScale: 1
  },
  crossContainer: {
    shape: 'cross',
    width: 40,
    height: 40,
    skewLeft: .5,
    skewRight: -.5,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    controlPosition: 1
  },
  jigsaw: {
    shape: 'jigsaw',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 5,
    color: '#e4e4e4',
    horizontal: true
  },
  jigsawContainer: {
    shape: 'jigsaw',
    width: 40,
    height: 40,
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    horizontal: true
  },
  borderedRectContainer: {
    shape: 'path',
    width: 40,
    height: 40,
    d: 'M-1 -1L1 -1L1 1L-1 1zM-0.7 0.7L0.7 0.7L0.7 -0.7L-0.7 -0.7zM-.4 -.4L.4 -.4L.4 .4L-.4 .4z',
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    shapeX: 0,
    shapeY: 0,
    shapeScale: 1
  },
  borderedCircleContainer: {
    shape: 'path',
    width: 40,
    height: 40,
    d: 'M0 -1A1 1 0 0 0 0 1A1 1 0 0 0 0 -1zM0 -.7A.7 .7 0 0 1 0 .7A.7 .7 0 0 1 0 -.7zM0 -.4A.4 .4 0 0 0 0 .4A.4 .4 0 0 0 0 -.4z',
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    shapeX: 0,
    shapeY: 0,
    shapeScale: 1
  },
  polygonRingContainer: {
    shape: 'path',
    width: 40,
    height: 40,
    d: 'M0 -1 L0.8660254037844386 -0.5000000000000001 L0.8660254037844387 0.4999999999999998 L1.2246467991473532e-16 1 L-0.8660254037844385 0.5000000000000004 L-0.8660254037844386 -0.5000000000000001zM-0.5196152422706631 -0.30000000000000004 L-0.519615242270663 0.30000000000000027 L7.347880794884119e-17 0.6 L0.5196152422706632 0.2999999999999999 L0.5196152422706631 -0.30000000000000004 L0 -0.6z',
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    shapeX: 0,
    shapeY: 0,
    shapeScale: 1
  },
  borderedPolygonContainer: {
    shape: 'path',
    width: 40,
    height: 40,
    d: 'M0 -1 L0.8660254037844386 -0.5000000000000001 L0.8660254037844387 0.4999999999999998 L1.2246467991473532e-16 1 L-0.8660254037844385 0.5000000000000004 L-0.8660254037844386 -0.5000000000000001zM-0.606217782649107 -0.35000000000000003 L-0.6062177826491069 0.3500000000000003 L8.572527594031472e-17 0.7 L0.6062177826491071 0.3499999999999998 L0.606217782649107 -0.35000000000000003 L0 -0.7zM0 -0.49 L0.4243524478543749 -0.24500000000000005 L0.424352447854375 0.24499999999999988 L6.000769315822031e-17 0.49 L-0.42435244785437487 0.24500000000000022 L-0.4243524478543749 -0.24500000000000005z',
    stroke: 'var(--color)',
    strokeWidth: 0,
    color: 'url(#containerPattern)',
    shapeX: 0,
    shapeY: 0,
    shapeScale: 1
  }
};

export default {
  name: "StyleMenu",
  components: {
    MenuHeader,
    TagMenu,
    ShapeRenderer
  },
  data() {
    return {
      opList: [
        { id: '1', title: '删除', attr: 'deleteBtn icon-delete1', 'opTextbtn': true, type: 'delete' },
        // { id: '2', title: '隐藏', attr: 'hideBtn icon-ziyuan78', 'opTextbtn': true },
        // { id: '3', title: '锁定', attr: 'lockBtn icon-suoding1', 'opTextbtn': true },
      ],
      tabs: [
        { tag: '图形', op: 'shape' },
        { tag: '容器', op: 'container' }
      ],
      currentTab: 'shape',
      containerGridList: containerGridIcons,
      containerType: 'all'
    };
  },
  computed: {
    shapeList() {
      const frag = this.$store.getters.activeFragment;
      const { effects: allEffects, shapeNames } = this.$store.state;
      return frag.effects.filter(efid => this.currentTab === 'shape'
        ? allEffects[efid].type === 'shape'
        : /^(?:text)?container$/i.test(allEffects[efid].type)).map(efid => {
          const ef = allEffects[efid];
          return {
            id: efid,
            showTracks: ef.showTracks,
            type: typeNames[ef.type],
            value: ef.content.name || (ef.type === 'textContainer' ? ef.content.text : shapeNames[ef.content.shape])
          };
        });
    },
    shapes() {
      const { shapes, shapeNames, shapeMetadata } = this.$store.state;
      return shapes.filter(s => s in displayParams).map(s => ({
        type: s,
        name: shapeNames[s],
        params: displayParams[s],
        desc: shapeMetadata[s].msg,
        id: shapeMetadata[s].id
      }));
    },
    containers() {
      const { containers, shapeNames, shapeMetadata } = this.$store.state;
      return containers.filter(s => s in displayParams).map(s => ({
        type: s,
        name: shapeNames[s],
        params: displayParams[s],
        desc: shapeMetadata[s].msg,
        id: shapeMetadata[s].id
      }));
    },
    selectedEffectId() {
      return this.$store.getters.selectedEffectId;
    },
    showContainers() {
      return this.containerType === 'all' || this.containerType === 'containers';
    },
    showGrids() {
      return this.containerType === 'all' || this.containerType === 'grids';
    }
  },
  methods: {
    ...mapActions(['processRemoveMaterialItem', 'addTextContainerItem']),
    add(type) {
      this.$store.dispatch('addShapeItem', type);
    },
    handleCurrentText: function (event) {
      this.$store.commit('handleTimelineFilter', '');
      this.$store.commit('handleEffectSelect', [event]);
    },
    async operate(e, type, id) {
      console.log(id);
      e.stopPropagation();
      const selected = id === this.selectedEffectId;
      switch (type) {
        case 'delete': {
          const done = await this.processRemoveMaterialItem(id);
          if (selected && done) {
            this.$store.commit('handleEffectSelect', []);
          }
          break;
        }
        default:
          console.log('unsupported operation type: ' + type);
      }
    },
    addContainer(type) {
      this.$store.dispatch('addContainerItem', type);
    },
    /**
     * @param{keyof containerGrids}type
     */
    addContainerGrid(type) {
      const { screenRatio, shapeNames } = this.$store.state;
      const width = screenRatio * 480;
      const arr = containerGrids[type]({
        w: width,
        h: 480,
        shapeNames
      });

      const curId = +new Date();

      const effectIds = arr.map((efc, i) => {
        const id = curId + 'g' + i;
        const effect = {
          id,
          type: 'container',
          locked: false,
          hidden: false,
          content: efc,
          children: [],
          enter: 'none',
          enterDuration: 1e3,
          leave: 'none',
          leaveDuration: 1e3,
          showTracks: false
        };
        this.$store.dispatch('processAddEffectItem', effect);
        return id;
      });

      this.$store.commit('handleEffectSelect', effectIds);
    }
  }
}
</script>

<style scoped>
.shape-menu {
  position: relative;
  padding: 10px 18px;
  overflow: scroll;
  max-height: 100%;
}

.shape-add {
  margin-bottom: 16px;
}

.shape-list {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
}

.shape-item {
  flex-shrink: 0;
  width: calc(100% / 3 - 14px);
  margin-right: 14px;
  margin-bottom: 11px;
  font-size: 12px;
  --color: #616161;
  position: relative;
}

.shape-item:hover .material-action-trigger {
  opacity: 0.7;
}

.shape-item .material-action-trigger:hover,
.shape-item .material-action-trigger:focus {
  opacity: 1;
}

.shape-icon {
  background: #fff;
  margin-bottom: 4px;
  padding: 0 0 100%;
  position: relative;
  transition: 0.2s;
  width: 100%;
  display: block;
  border: 0;
  outline: 0;
  border-radius: 0;
  cursor: pointer;
}

.shape-icon__shape {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.shape-icon:hover,
.shape-icon:focus {
  color: #007eff;
  --color: #007eff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.shape-icon:active {
  box-shadow: 0 0 0 transparent, inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.container-grid-item {
  --color: #dcdcdc;
}

.text-clip-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.text-clip-group-txt {
  width: 100%;
  height: 52px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e5e5e7;
  border-radius: 2px;
  color: rgba(101, 102, 103, 1);
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  z-index: 0;
}

.text-clip-group-txt:hover,
.text-clip-group-txt--active {
  border: 1px solid rgba(0, 126, 255, 1);
}

.text-clip-tip {
  width: 62px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  opacity: 0;
  transition: 0.2s;
  position: absolute;
  top: 50%;
  left: 10px;
  margin-top: -11px;
  background: rgba(245, 166, 35, 1);
  border-radius: 4px;
  font-size: 10px;
  padding: 0 7px;
  color: #fff;
  box-shadow: 5px 0 6px -3px #fff;
}

.text-clip-txt {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text-clip-op {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.2s;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -12px;
  background: linear-gradient(to right, transparent, #fff 24px);
  padding-left: 10px;
}
.text-clip-group-txt:hover .text-clip-tip,
.text-clip-group-txt:hover .text-clip-op {
  opacity: 1;
}
.text-clip-op .icon {
  font-size: 14px;
  color: #5f5f5f;
  margin: 0 0 0 8px;
  text-align: center;
  padding: 0 4px;
  border: 0;
  background: transparent;
  outline: none;
}
.text-clip-op .icon.icon-suoding1 {
  font-weight: bold;
}

.text-clip-group .icon:hover,
.text-clip-group .icon:focus {
  color: #007eff;
}

.header-radio-group {
  margin: -4px 0 12px;
  display: flex;
}

.header-radio-group .ant-radio-button-wrapper {
  padding: 0;
}
</style>
<style>
.shape-menu-overlay {
  max-width: 240px;
}

.shape-menu-overlay__name {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
}

.shape-menu-overlay__desc {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin: 4px 0 0;
}
</style>